import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
//import axios from "axios"
import axios from "../../../src/core/api/axiosClientOTA";
import getFileExtension from "src/shared/helpers/get-file-extension";

const initialState: any = {
  ota: [],
  otaDetails: [],
  otaAdd: [],
  otaEdit: [],
  otaPublish: [],
  slsSupplier: [],
  assetModelBySLSSupplier: [],
  isLoading: false,
  OTAPublishDeviceById: false,
  otaStatusTableData: [],
  isLoadingDownload: false,
  otaDownloadData: [],
  error: null,
};

// export const getOTA: any = createAsyncThunk('content/getOTA',
//     async ({ PageNumber, pageSize }: any) => {
//         const res = await axios('http://localhost:3000/ota', {
//             params: { PageNumber, pageSize }
//         });
//         const data = await res.data

//         return data
//     }
// )

// export const getOTAById: any = createAsyncThunk('content/getOTAById',
//     async ({ id }: any) => {
//         const res = await axios(`http://localhost:3000/ota-${id}`);
//         const data = await res.data;

//         return data
//     }
// )

export const getAssetModelBySLSSupplier: any = createAsyncThunk(
  "content/getAssetModelBySLSSupplier",
  async ({ supplierId }: any) => {
    const res = await axios.get(`/OTA/GetAllAssetModelBySupplier`, {
      params: { supplierId },
    });
    const data = await res.data;

    return data;
  }
);

export const getSLSSupplier: any = createAsyncThunk(
  "content/getSLSSupplier",
  async () => {
    const res = await axios.get(`/OTA/GetAllSupplier`);
    const data = await res?.data;
    return data;
  }
);

export const getOTAById: any = createAsyncThunk(
  "content/getOTAById",
  async ({ Id }: any) => {
    const res = await axios.get(`/OTA/GetOtaById`, {
      params: { Id },
    });
    const data = await res.data?.data;
    // debugger;

    return data;
  }
);

export const getDownloadOTAbyAssetModel: any = createAsyncThunk(
  "content/getDownloadOTAbyAssetModel",
  async ({ Id }: any) => {
    try {
      const res = await axios.get(`/OTA/Download`, {
        params: { Id },
        headers: {
          "Content-Type": "application/json",
        },
        responseType: "blob",
      });
      //  ;
      const data = res.data;
      const contentType: any = res.headers["content-type"];

      let contentDisposition = res.headers["content-disposition"];

      // const contentDisposition =
      //   "attachment; filename=ota_file-SJ-version-7.zip; filename*=UTF-8''ota_file-SJ-version-7.zip";

      let filename = contentDisposition
        .split(";")
        .map((part: string) => part.trim())
        .find(
          (part: string) =>
            part.startsWith("filename=") || part.startsWith("filename*=")
        )
        ?.split("=")[1];

      // Remove the quotes if they exist
      if (filename) {
        filename = filename.replace(/^['"]|['"]$/g, "");
        filename = filename.replace(/(\.zip|\.tar)$/, "");
      }

      const fileBlob = new Blob([data], {
        type: contentType,
      });

      const fileUrl = URL.createObjectURL(fileBlob);

      const link = document.createElement("a");
      link.href = fileUrl;

      link.download = filename + getFileExtension(contentType);

      link.click();

      URL.revokeObjectURL(fileUrl);

      return data;
    } catch (error) {
      console.error("Error downloading OTA:", error);
      throw error;
    }
  }
);

export const getOTA: any = createAsyncThunk(
  "content/getOTA",
  async ({
    PageNumber: PageNum,
    pageSize,
    SortBy,
    SortDirection,
    SearchText = null,
  }: any) => {
    const res = await axios.get(`/OTA/Get`, {
      params: { PageNum, pageSize, SortBy, SortDirection, SearchText },
    });
    const data = await res.data;

    return data;
  }
);

export const getOTAPublishDeviceById: any = createAsyncThunk(
  "content/getOTAPublishDeviceById",
  async ({
    otaId,
    PageNumber: PageNumber,
    pageSize,
    SortBy,
    SortDirection,
    SearchText,
    IsAcknowledged
  }: any) => {
    const res = await axios.get(`/OTA/GetOTAPublishDeviceListHistory`, {
      params: { otaId, PageNumber, pageSize, SortBy, SortDirection,SearchText,IsAcknowledged },
    });
    const data = await res.data;

    return data;
  }
);

export const editOta: any = createAsyncThunk(
  "content/editOta",

  async ({ payload, id: Id, file }: any) => {
    try {
      const formData = new FormData();
      // debugger;
      formData.append("Id", Id);
      formData.append("OTAUploadFile", file);
      formData.append("UploadedFileAWSURL", payload.currentAWSLink);
      formData.append("AssetModel", payload.AssetModel);
      formData.append("SupplierId", payload.SupplierId);

      formData.append("Checksum", payload.checksum);
      formData.append("FirmwareVersion", payload.FirmwareVersion);
      formData.append("Description", payload.Description);

      const response = await axios.put(`/OTA/Update`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
        params: { Id },
      });

      return response.data;
    } catch (error) {
      console.error("Error uploading-file/ form sending:", error);
      throw error;
    }
  }
);

export const addOta: any = createAsyncThunk(
  "content/addOta",

  async ({ payload, file }: any) => {
    try {
      const formData = new FormData();
      formData.append("OTAUploadFile", file);
      formData.append("AssetModel", payload.AssetModel);
      formData.append("SupplierId", payload.SupplierId);
      formData.append("Checksum", payload.checksum);
      formData.append("FirmwareVersion", payload.FirmwareVersion);
      formData.append("Description", payload.Description);

      // debugger;
      const response = await axios.post(`/OTA/Insert`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      // debugger;

      return response.data;
    } catch (error) {
      console.error("Error uploading-file/ form sending:", error);
      throw error;
    }
  }
);

export const deleteOta: any = createAsyncThunk(
  "content/deleteOta",
  async ({ id: Id }: any) => {
    const res = await axios.delete(`/OTA/Delete`, {
      params: { Id },
    });

    const data = await res.data.data;
    return data;
  }
);

export const publishOta: any = createAsyncThunk(
  "content/publishOta",
  async ({ payload }: any) => {
    const res = await axios.post(`/OTA/publishOTA`, payload, {
      headers: {
        "Content-Type": "application/json",
      },
    });

    const data = await res.data;
    return data;
  }
);

export const otaSlice = createSlice({
  name: "ota",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getOTA.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(getOTA.fulfilled, (state, action) => {
      state.isLoading = false;
      state.ota = action.payload;
    });
    builder.addCase(getOTA.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.error.message;
    });

    builder.addCase(getOTAPublishDeviceById.pending, (state) => {
      state.isLoadingOTAPublishDeviceById = true;
    });
    builder.addCase(getOTAPublishDeviceById.fulfilled, (state, action) => {
      state.isLoadingOTAPublishDeviceById = false;
      state.otaStatusTableData = action.payload;
    });
    builder.addCase(getOTAPublishDeviceById.rejected, (state, action) => {
      state.isLoadingOTAPublishDeviceById = false;
      state.error = action.error.message;
    });

    builder.addCase(getOTAById.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(getOTAById.fulfilled, (state, action) => {
      state.isLoading = false;
      state.otaDetails = action.payload;
    });
    builder.addCase(getOTAById.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.error.message;
    });

    builder.addCase(getDownloadOTAbyAssetModel.pending, (state) => {
      state.isLoadingDownload = true;
    });
    builder.addCase(getDownloadOTAbyAssetModel.fulfilled, (state, action) => {
      state.isLoadingDownload = false;
      state.otaDownloadData = action.payload;
    });
    builder.addCase(getDownloadOTAbyAssetModel.rejected, (state, action) => {
      state.isLoadingDownload = false;
      state.error = action.error.message;
    });

    builder.addCase(addOta.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(addOta.fulfilled, (state, action) => {
      state.isLoading = false;
      state.otaAdd = action.payload;
    });
    builder.addCase(addOta.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.error.message;
    });

    builder.addCase(editOta.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(editOta.fulfilled, (state, action) => {
      state.isLoading = false;
      state.otaEdit = action.payload;
    });
    builder.addCase(editOta.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.error.message;
    });

    builder.addCase(publishOta.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(publishOta.fulfilled, (state, action) => {
      state.isLoading = false;
      state.otaPublish = action.payload;
    });
    builder.addCase(publishOta.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.error.message;
    });

    builder.addCase(getSLSSupplier.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(getSLSSupplier.fulfilled, (state, action) => {
      state.isLoading = false;
      state.slsSupplier = action.payload;
    });
    builder.addCase(getSLSSupplier.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.error.message;
    });

    builder.addCase(getAssetModelBySLSSupplier.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(getAssetModelBySLSSupplier.fulfilled, (state, action) => {
      state.isLoading = false;
      state.assetModelBySLSSupplier = action.payload;
    });
    builder.addCase(getAssetModelBySLSSupplier.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.error.message;
    });
  },
});

export default otaSlice.reducer;
